import * as v from 'valibot';
import { zigbeeGUISchema } from '../ZigbeeGUI';
import { groupsSchema } from './Groups';
import { clusterIdSchema, endpointIdSchema } from '../../util/valibot';
export const endpointSchema = v.object({
    clusters: v.array(clusterIdSchema),
    device: v.number(),
    device_name: v.string(),
    device_version: v.number(),
    eid: endpointIdSchema,
    endpoint: endpointIdSchema,
    gui: zigbeeGUISchema,
    input_clusters: v.array(clusterIdSchema),
    output_clusters: v.array(clusterIdSchema),
    groups: v.pipe(v.nullish(groupsSchema), v.transform((x) => x !== null && x !== void 0 ? x : undefined)),
    profile: v.number(),
    profile_name: v.string(),
    zigbee_node_id: v.number(),
});
export const endpointMapSchema = v.pipe(v.array(endpointSchema), v.transform((es) => {
    const m = {};
    for (const e of es) {
        m[e.endpoint] = e;
    }
    return m;
}));
